<script lang="ts">
  import { Button } from "$lib/components/ui/button/index.js";
  import * as Dialog from "$lib/components/ui/dialog/index.js";
  import { goto } from "$app/navigation";
  import { routes } from "$lib/routes";

  export let title: string = "Log In";
  export let message: string = "You need to be logged in to do this.";
  export let open: boolean = false;

  function handleButtonClick() {
    const event = new CustomEvent("dialogAction");
    window.dispatchEvent(event);
  }
</script>

<Dialog.Root bind:open>
  <Dialog.Portal>
    <Dialog.Overlay class="fixed inset-0 bg-white/70 dark:bg-black/70" />

    <Dialog.Content
      class="fixed left-1/2 top-1/2 w-full max-w-md -translate-x-1/2 -translate-y-1/2 !rounded-base border border-gray-200 bg-theme-background-primary p-6 shadow-lg dark:border-white/40 dark:bg-theme-background-tertiary"
    >
      <Dialog.Header>
        <Dialog.Title class="text-lg font-semibold text-theme-text-primary dark:text-theme-gray-800">
          {title}
        </Dialog.Title>
        <Dialog.Description class="mt-2 text-sm text-theme-text-secondary dark:text-theme-gray-500">
          {message}
        </Dialog.Description>
      </Dialog.Header>

      <Dialog.Footer class="mt-6 flex w-full justify-around gap-3">
        <Button onclick={() => goto(routes.signIn)} class="w-full !rounded-base">Log In</Button>
        <Button
          onclick={() => goto(routes.signUp)}
          variant="outline"
          class="w-full !rounded-base border-gray-200 hover:bg-gray-50 dark:border-white/40 dark:bg-theme-background-primary dark:hover:bg-theme-background-primary"
        >
          Sign Up
        </Button>
      </Dialog.Footer>
    </Dialog.Content>
  </Dialog.Portal>
</Dialog.Root>
